import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

export const popover: {
  defaultProps?: ComponentsProps['MuiPopover'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiPopover'];
  variants?: ComponentsVariants<Theme>['MuiPopover'];
} = {
  defaultProps: {
    elevation: 0
  },
  styleOverrides: {
    root({ theme }) {
      return {
        '.MuiPaper-root': {
          boxShadow: theme.customShadows.card,
          border: `solid 1px ${theme.palette.grey[800]}`,
          background: theme.palette.grey[950],
          '.MuiTypography-root:hover': {
            background: 'transparent'
          },
          // Un popover ancré à un bouton se positionne par rapport à lui : sur
          // un écran étroit il sort du cadre par la droite ou par le bas. On
          // le borne à ce qui reste réellement visible, marges de sécurité
          // comprises, et on le laisse défiler plutôt que déborder.
          [theme.breakpoints.down('md')]: {
            maxWidth: 'calc(100vw - 24px)',
            maxHeight: 'calc(80vh - var(--safe-top) - var(--safe-bottom))',
            overflowY: 'auto'
          }
        }
      };
    }
  }
};
